import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const PathCard = ({ variant = "dark", icon: Icon, eyebrow, heading, sub, lines = [], ctaLabel, to, statLabel, statDesc, testId }) => {
  const isDark = variant === "dark";
  return (
    <div
      data-testid={testId}
      className={`flex flex-col justify-between p-8 sm:p-14 lg:p-20 ${isDark ? "bg-true-black text-clean-white" : "bg-warm-white text-midnight-black"}`}
    >
      <div>
        <div className={`w-14 h-14 rounded-full flex items-center justify-center mb-8 ${isDark ? "bg-stranger-orange/15" : "bg-stranger-orange/10"}`}>
          <Icon className="w-7 h-7 text-stranger-orange" strokeWidth={1.75} />
        </div>
        <p className="text-xs font-bold tracking-[0.2em] mb-3 opacity-60 uppercase">{eyebrow}</p>
        <h3 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight mb-3">{heading}</h3>
        <p className="text-stranger-orange font-bold mb-5 text-lg">{sub}</p>
        <div className="space-y-1 mb-10 opacity-80 text-sm sm:text-base font-medium">
          {lines.map((l) => (
            <p key={l}>{l}</p>
          ))}
        </div>
        <Link to={to} data-testid={`${testId}-cta`}>
          <button className="inline-flex items-center justify-center gap-2 bg-stranger-orange text-clean-white font-bold tracking-widest text-xs px-8 py-4 rounded-full hover:bg-orange-600 transition-colors">
            {ctaLabel} <ArrowRight className="w-4 h-4" />
          </button>
        </Link>
      </div>

      {statLabel && (
        <div className={`border rounded-xl p-5 mt-12 ${isDark ? "border-white/20" : "border-midnight-black/15"}`} data-testid={`${testId}-stat`}>
          <p className="font-extrabold text-sm uppercase tracking-wide">{statLabel}</p>
          <p className="text-xs opacity-70 font-medium mt-1.5">{statDesc}</p>
        </div>
      )}
    </div>
  );
};
